import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

export default function ServiceTemplate({
  title,
  bannerImage,
  bigImage,
  collageImage,
  features = [],
  sidebarItems = [],
  contact = true
}) {

  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [bigLoaded, setBigLoaded] = useState(false);
  const [collageLoaded, setCollageLoaded] = useState(false);

  return (
    <div className="bg-gray-100">
      {/* HERO */}
      <div className="relative w-full h-72 sm:h-70 md:h-96 lg:h-[420px] overflow-hidden">

        {/* ⭐ Shimmer Placeholder */}
        {!bannerLoaded && (
          <div className="absolute inset-0 shimmer rounded-none" />
        )}

        <img
          src={bannerImage}
          alt={`${title} banner`}
          className={`w-full h-full object-cover transition-opacity duration-700 ${
            bannerLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setBannerLoaded(true)}
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/40" />
        <h1
          className="absolute inset-0 flex items-center justify-center text-white 
          text-3xl sm:text-4xl md:text-5xl font-bold tracking-wide"
          data-aos="fade-up"
        >
          {title}
        </h1>
      </div>

      {/* CONTAINER */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* ROW 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-10">

          {/* SIDEBAR */}
          <div className="space-y-4" data-aos="fade-right">
            {sidebarItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-4 rounded-xl shadow flex items-center gap-4 hover:shadow-md transition"
                >
                  {Icon && <Icon className="text-2xl text-black" />}
                  <span className="font-medium text-gray-700 text-base">
                    {item.title}
                  </span>
                </div>
              );
            })}
          </div>

          {/* BIG IMAGE */}
          <div className="lg:col-span-2 relative" data-aos="fade-left">

            {/* ⭐ Shimmer */}
            {!bigLoaded && (
              <div className="absolute inset-0 shimmer rounded-xl" />
            )}

            <img
  src={bigImage}
  alt={`${title} big`}
  className={`rounded-xl shadow-lg w-full h-[320px] sm:h-[360px] md:h-[420px] 
  object-cover transition-opacity duration-700 
  brightness-75 contrast-90 ${
    bigLoaded ? "opacity-100" : "opacity-0"
  }`}
  onLoad={() => setBigLoaded(true)}
  loading="lazy"
/>

          </div>
        </div>

        {/* ROW 2 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">

          {/* CONTACT FORM */}
          {contact && (
            <div className="bg-white p-6 rounded-xl shadow-lg" data-aos="fade-right">
              <h3 className="font-semibold mb-4 text-lg text-center">Contact Us</h3>
              <form className="space-y-3">
                <input className="w-full border px-3 py-2 rounded-lg" placeholder="Name" />
                <input className="w-full border px-3 py-2 rounded-lg" placeholder="Mobile Number" />
                <input className="w-full border px-3 py-2 rounded-lg" placeholder="Email" />
                <textarea className="w-full border px-3 py-2 rounded-lg h-20" placeholder="Subject"></textarea>
                <button className="bg-[#1E0D0D] text-white w-full py-2 rounded-lg">Submit</button>
              </form>
            </div>
          )}

          {/* WHAT WE OFFER */}
          <div data-aos="fade-up">
            <h2 className="text-2xl font-bold mb-4">What We Offer:</h2>
            <ul className="space-y-4 text-gray-700">
              {features.map((f, index) => (
                <li key={index} className="flex items-start gap-3">
                  <FaCheckCircle className="text-green-600 mt-1" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* COLLAGE IMAGE */}
          <div data-aos="fade-left" className="flex justify-center relative">

            {/* ⭐ Shimmer */}
            {!collageLoaded && (
              <div className="absolute inset-0 shimmer rounded-xl" />
            )}

            <img
              src={collageImage}
              alt={`${title} collage`}
              className={`rounded-xl shadow-lg w-full h-[420px] object-cover border transition-opacity duration-700 ${
                collageLoaded ? "opacity-100" : "opacity-0"
              }`}
              onLoad={() => setCollageLoaded(true)}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
